import(/* webpackMode: "eager" */ "/app/apps/admin/src/app/error.tsx");
